import { siteConfig } from "./config/site";

export function initFooterContact(): void {
  for (const slot of document.querySelectorAll("[data-footer-contact]")) {
    slot.textContent = "";
    slot.classList.add("site-footer__contact");

    const ig = document.createElement("a");
    ig.href = siteConfig.contact.instagramUrl;
    ig.target = "_blank";
    ig.rel = "noopener noreferrer";
    ig.className = "site-footer__contact-link";
    ig.textContent = `@${siteConfig.contact.instagramHandle}`;

    const wa = document.createElement("a");
    wa.href = `https://wa.me/${siteConfig.contact.whatsappE164}`;
    wa.target = "_blank";
    wa.rel = "noopener noreferrer";
    wa.className = "site-footer__contact-link";
    wa.textContent = "WhatsApp pedidos";

    const hint = document.createElement("p");
    hint.className = "site-footer__contact-hint";
    hint.textContent =
      "Somos Claudia y Guillermo, desde Medellín. Máximo 10 unidades por tipo de producto en cada diseño — así lo que compras no está en todas partes.";

    const links = document.createElement("div");
    links.className = "site-footer__contact-links";
    links.appendChild(ig);
    links.appendChild(wa);

    slot.appendChild(hint);
    slot.appendChild(links);
  }
}
